import { render, staticRenderFns } from "./SideBarProduction.vue?vue&type=template&id=7c4155c4"
import script from "./SideBarProduction.vue?vue&type=script&lang=js"
export * from "./SideBarProduction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports